export enum TaxRatePermissions {
  GET_TAX_RATES = 'taxRates.getTaxRates',
  PERSIST_TAX_RATE = 'taxRates.persistTaxRate',
  DELETE_TAX_RATE = 'taxRates.deleteTaxRate',
}
